"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRY_CODE_OPTIONS = [
    { code: 'AF', value: '93', label: '+93' },
    { code: 'AL', value: '355', label: '+355' },
    { code: 'DZ', value: '213', label: '+213' },
    { code: 'AS', value: '1-684', label: '+1-684' },
    { code: 'AD', value: '376', label: '+376' },
    { code: 'AO', value: '244', label: '+244' },
    { code: 'AI', value: '1-264', label: '+1-264' },
    { code: 'AQ', value: '672', label: '+672' },
    { code: 'AG', value: '1-268', label: '+1-268' },
    { code: 'AR', value: '54', label: '+54' },
    { code: 'AM', value: '374', label: '+374' },
    { code: 'AW', value: '297', label: '+297' },
    { code: 'AU', value: '61', label: '+61' },
    { code: 'AT', value: '43', label: '+43' },
    { code: 'AZ', value: '994', label: '+994' },
    { code: 'BS', value: '1-242', label: '+1-242' },
    { code: 'BH', value: '973', label: '+973' },
    { code: 'BD', value: '880', label: '+880' },
    { code: 'BB', value: '1-246', label: '+1-246' },
    { code: 'BY', value: '375', label: '+375' },
    { code: 'BE', value: '32', label: '+32' },
    { code: 'BZ', value: '501', label: '+501' },
    { code: 'BJ', value: '229', label: '+229' },
    { code: 'BM', value: '1-441', label: '+1-441' },
    { code: 'BT', value: '975', label: '+975' },
    { code: 'BO', value: '591', label: '+591' },
    { code: 'BA', value: '387', label: '+387' },
    { code: 'BW', value: '267', label: '+267' },
    { code: 'BR', value: '55', label: '+55' },
    { code: 'IO', value: '246', label: '+246' },
    { code: 'VG', value: '1-284', label: '+1-284' },
    { code: 'BN', value: '673', label: '+673' },
    { code: 'BG', value: '359', label: '+359' },
    { code: 'BF', value: '226', label: '+226' },
    { code: 'BI', value: '257', label: '+257' },
    { code: 'KH', value: '855', label: '+855' },
    { code: 'CM', value: '237', label: '+237' },
    { code: 'CA', value: '1', label: '+1' },
    { code: 'CV', value: '238', label: '+238' },
    { code: 'KY', value: '1-345', label: '+1-345' },
    { code: 'CF', value: '236', label: '+236' },
    { code: 'TD', value: '235', label: '+235' },
    { code: 'CL', value: '56', label: '+56' },
    { code: 'CN', value: '86', label: '+86' },
    { code: 'CX', value: '61', label: '+61' },
    { code: 'CC', value: '61', label: '+61' },
    { code: 'CO', value: '57', label: '+57' },
    { code: 'KM', value: '269', label: '+269' },
    { code: 'CK', value: '682', label: '+682' },
    { code: 'CR', value: '506', label: '+506' },
    { code: 'HR', value: '385', label: '+385' },
    { code: 'CU', value: '53', label: '+53' },
    { code: 'CW', value: '599', label: '+599' },
    { code: 'CY', value: '357', label: '+357' },
    { code: 'CZ', value: '420', label: '+420' },
    { code: 'CD', value: '243', label: '+243' },
    { code: 'DK', value: '45', label: '+45' },
    { code: 'DJ', value: '253', label: '+253' },
    { code: 'DM', value: '1-767', label: '+1-767' },
    { code: 'DO', value: '1-849', label: '+1-849' },
    { code: 'TL', value: '670', label: '+670' },
    { code: 'EC', value: '593', label: '+593' },
    { code: 'EG', value: '20', label: '+20' },
    { code: 'SV', value: '503', label: '+503' },
    { code: 'GQ', value: '240', label: '+240' },
    { code: 'ER', value: '291', label: '+291' },
    { code: 'EE', value: '372', label: '+372' },
    { code: 'ET', value: '251', label: '+251' },
    { code: 'FK', value: '500', label: '+500' },
    { code: 'FO', value: '298', label: '+298' },
    { code: 'FJ', value: '679', label: '+679' },
    { code: 'FI', value: '358', label: '+358' },
    { code: 'FR', value: '33', label: '+33' },
    { code: 'PF', value: '689', label: '+689' },
    { code: 'GA', value: '241', label: '+241' },
    { code: 'GM', value: '220', label: '+220' },
    { code: 'GE', value: '995', label: '+995' },
    { code: 'DE', value: '49', label: '+49' },
    { code: 'GH', value: '233', label: '+233' },
    { code: 'GI', value: '350', label: '+350' },
    { code: 'GR', value: '30', label: '+30' },
    { code: 'GL', value: '299', label: '+299' },
    { code: 'GD', value: '1-473', label: '+1-473' },
    { code: 'GU', value: '1-671', label: '+1-671' },
    { code: 'GT', value: '502', label: '+502' },
    { code: 'GG', value: '44-1481', label: '+44-1481' },
    { code: 'GN', value: '224', label: '+224' },
    { code: 'GW', value: '245', label: '+245' },
    { code: 'GY', value: '592', label: '+592' },
    { code: 'HT', value: '509', label: '+509' },
    { code: 'HN', value: '504', label: '+504' },
    { code: 'HK', value: '852', label: '+852' },
    { code: 'HU', value: '36', label: '+36' },
    { code: 'IS', value: '354', label: '+354' },
    { code: 'IN', value: '91', label: '+91' },
    { code: 'ID', value: '62', label: '+62' },
    { code: 'IR', value: '98', label: '+98' },
    { code: 'IQ', value: '964', label: '+964' },
    { code: 'IE', value: '353', label: '+353' },
    { code: 'IM', value: '44-1624', label: '+44-1624' },
    { code: 'IL', value: '972', label: '+972' },
    { code: 'IT', value: '39', label: '+39' },
    { code: 'CI', value: '225', label: '+225' },
    { code: 'JM', value: '1-876', label: '+1-876' },
    { code: 'JP', value: '81', label: '+81' },
    { code: 'JE', value: '44-1534', label: '+44-1534' },
    { code: 'JO', value: '962', label: '+962' },
    { code: 'KZ', value: '7', label: '+7' },
    { code: 'KE', value: '254', label: '+254' },
    { code: 'KI', value: '686', label: '+686' },
    { code: 'XK', value: '383', label: '+383' },
    { code: 'KW', value: '965', label: '+965' },
    { code: 'KG', value: '996', label: '+996' },
    { code: 'LA', value: '856', label: '+856' },
    { code: 'LV', value: '371', label: '+371' },
    { code: 'LB', value: '961', label: '+961' },
    { code: 'LS', value: '266', label: '+266' },
    { code: 'LR', value: '231', label: '+231' },
    { code: 'LY', value: '218', label: '+218' },
    { code: 'LI', value: '423', label: '+423' },
    { code: 'LT', value: '370', label: '+370' },
    { code: 'LU', value: '352', label: '+352' },
    { code: 'MO', value: '853', label: '+853' },
    { code: 'MK', value: '389', label: '+389' },
    { code: 'MG', value: '261', label: '+261' },
    { code: 'MW', value: '265', label: '+265' },
    { code: 'MY', value: '60', label: '+60' },
    { code: 'MV', value: '960', label: '+960' },
    { code: 'ML', value: '223', label: '+223' },
    { code: 'MT', value: '356', label: '+356' },
    { code: 'MH', value: '692', label: '+692' },
    { code: 'MR', value: '222', label: '+222' },
    { code: 'MU', value: '230', label: '+230' },
    { code: 'YT', value: '262', label: '+262' },
    { code: 'MX', value: '52', label: '+52' },
    { code: 'FM', value: '691', label: '+691' },
    { code: 'MD', value: '373', label: '+373' },
    { code: 'MC', value: '377', label: '+377' },
    { code: 'MN', value: '976', label: '+976' },
    { code: 'ME', value: '382', label: '+382' },
    { code: 'MS', value: '1-664', label: '+1-664' },
    { code: 'MA', value: '212', label: '+212' },
    { code: 'MZ', value: '258', label: '+258' },
    { code: 'MM', value: '95', label: '+95' },
    { code: 'NA', value: '264', label: '+264' },
    { code: 'NR', value: '674', label: '+674' },
    { code: 'NP', value: '977', label: '+977' },
    { code: 'NL', value: '31', label: '+31' },
    { code: 'AN', value: '599', label: '+599' },
    { code: 'NC', value: '687', label: '+687' },
    { code: 'NZ', value: '64', label: '+64' },
    { code: 'NI', value: '505', label: '+505' },
    { code: 'NE', value: '227', label: '+227' },
    { code: 'NG', value: '234', label: '+234' },
    { code: 'NU', value: '683', label: '+683' },
    { code: 'KP', value: '850', label: '+850' },
    { code: 'MP', value: '1-670', label: '+1-670' },
    { code: 'NO', value: '47', label: '+47' },
    { code: 'OM', value: '968', label: '+968' },
    { code: 'PK', value: '92', label: '+92' },
    { code: 'PW', value: '680', label: '+680' },
    { code: 'PS', value: '970', label: '+970' },
    { code: 'PA', value: '507', label: '+507' },
    { code: 'PG', value: '675', label: '+675' },
    { code: 'PY', value: '595', label: '+595' },
    { code: 'PE', value: '51', label: '+51' },
    { code: 'PH', value: '63', label: '+63' },
    { code: 'PN', value: '64', label: '+64' },
    { code: 'PL', value: '48', label: '+48' },
    { code: 'PT', value: '351', label: '+351' },
    { code: 'PR', value: '1-939', label: '+1-939' },
    { code: 'QA', value: '974', label: '+974' },
    { code: 'CG', value: '242', label: '+242' },
    { code: 'RE', value: '262', label: '+262' },
    { code: 'RO', value: '40', label: '+40' },
    { code: 'RU', value: '7', label: '+7' },
    { code: 'RW', value: '250', label: '+250' },
    { code: 'BL', value: '590', label: '+590' },
    { code: 'SH', value: '290', label: '+290' },
    { code: 'KN', value: '1-869', label: '+1-869' },
    { code: 'LC', value: '1-758', label: '+1-758' },
    { code: 'MF', value: '590', label: '+590' },
    { code: 'PM', value: '508', label: '+508' },
    { code: 'VC', value: '1-784', label: '+1-784' },
    { code: 'WS', value: '685', label: '+685' },
    { code: 'SM', value: '378', label: '+378' },
    { code: 'ST', value: '239', label: '+239' },
    { code: 'SA', value: '966', label: '+966' },
    { code: 'SN', value: '221', label: '+221' },
    { code: 'RS', value: '381', label: '+381' },
    { code: 'SC', value: '248', label: '+248' },
    { code: 'SL', value: '232', label: '+232' },
    { code: 'SG', value: '65', label: '+65' },
    { code: 'SX', value: '1-721', label: '+1-721' },
    { code: 'SK', value: '421', label: '+421' },
    { code: 'SI', value: '386', label: '+386' },
    { code: 'SB', value: '677', label: '+677' },
    { code: 'SO', value: '252', label: '+252' },
    { code: 'ZA', value: '27', label: '+27' },
    { code: 'KR', value: '82', label: '+82' },
    { code: 'SS', value: '211', label: '+211' },
    { code: 'ES', value: '34', label: '+34' },
    { code: 'LK', value: '94', label: '+94' },
    { code: 'SD', value: '249', label: '+249' },
    { code: 'SR', value: '597', label: '+597' },
    { code: 'SJ', value: '47', label: '+47' },
    { code: 'SZ', value: '268', label: '+268' },
    { code: 'SE', value: '46', label: '+46' },
    { code: 'CH', value: '41', label: '+41' },
    { code: 'SY', value: '963', label: '+963' },
    { code: 'TW', value: '886', label: '+886' },
    { code: 'TJ', value: '992', label: '+992' },
    { code: 'TZ', value: '255', label: '+255' },
    { code: 'TH', value: '66', label: '+66' },
    { code: 'TG', value: '228', label: '+228' },
    { code: 'TK', value: '690', label: '+690' },
    { code: 'TO', value: '676', label: '+676' },
    { code: 'TT', value: '1-868', label: '+1-868' },
    { code: 'TN', value: '216', label: '+216' },
    { code: 'TR', value: '90', label: '+90' },
    { code: 'TM', value: '993', label: '+993' },
    { code: 'TC', value: '1-649', label: '+1-649' },
    { code: 'TV', value: '688', label: '+688' },
    { code: 'VI', value: '1-340', label: '+1-340' },
    { code: 'UG', value: '256', label: '+256' },
    { code: 'UA', value: '380', label: '+380' },
    { code: 'AE', value: '971', label: '+971' },
    { code: 'GB', value: '44', label: '+44' },
    { code: 'US', value: '1', label: '+1' },
    { code: 'UY', value: '598', label: '+598' },
    { code: 'UZ', value: '998', label: '+998' },
    { code: 'VU', value: '678', label: '+678' },
    { code: 'VA', value: '379', label: '+379' },
    { code: 'VE', value: '58', label: '+58' },
    { code: 'VN', value: '84', label: '+84' },
    { code: 'WF', value: '681', label: '+681' },
    { code: 'EH', value: '212', label: '+212' },
    { code: 'YE', value: '967', label: '+967' },
    { code: 'ZM', value: '260', label: '+260' },
    { code: 'ZW', value: '263', label: '+263' },
];
//# sourceMappingURL=countryCodes.js.map